import React from 'react';
import "./style.css";

const DDA = () => {
  return (
    // DDA section starts
    <section className="section DDA-section">
        <div className="container">
            <div className="row DDA">
                Designed and Developed by Ashik S Nair &copy; 2022
            </div>
        </div>
    </section>
    // DDA section ends
  )
}

export default DDA;